import React from 'react';
import PropTypes from 'prop-types';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function CopyButton({
  content, onClick, disabled, title,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faClone}
      title={title}
    />
  );
}

CopyButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

CopyButton.defaultProps = {
  onClick: () => null,
  content: 'Скопіювати',
  disabled: false,
  title: 'Скопіювати',
};

export default CopyButton;
